export const COMPLETION_MODELS = [
  {
    key: 'standard-completion',
    label: 'Google Gemini 2.0 Flash',
    description:
      'Our default model for a wide variety of everyday text-based chats.'
  },
  {
    key: 'openai-standard-completion',
    label: 'OpenAI 4o-mini',
    description: 'Try a different model to see how it impacts the responses.'
  }
  // {
  //   key: 'mythomax-completion',
  //   label: 'Mythomax',
  //   description:
  //     'Great for creative conversations like storytelling and roleplaying.'
  // },
  // {
  //   key: 'wizardlm-completion',
  //   label: 'WizardLM',
  //   description:
  //     'Specialized in following complex instructions with impressive accuracy and logical reasoning abilities.'
  // },
  // {
  //   key: 'mistral-completion',
  //   label: 'Mistral',
  //   description:
  //     'Quick and accurate answers in many different languages and can handle long conversations.'
  // },
  // {
  //   key: 'claude-completion',
  //   label: 'Claude',
  //   description:
  //     'Well-balanced AI that excels at thoughtful, detailed responses and careful analysis of complex topics.'
  // }
] as const;

export const COMPLETION_MODEL_KEYS = COMPLETION_MODELS.map(
  (model) => model.key
);

export type CompletionModelKey = (typeof COMPLETION_MODEL_KEYS)[number];
